import { api } from "./api";
export const ActionType = {
  Data: "Data",
  List: "List",
  AddItem: "AddItem",
  UpdateItem: "UpdateItem",
  Delete: "Delete",
  RmvList: "RmvList",
  RmvStore: "RmvStore",
  ClearLi: "ClearLi",
  ClearData: "ClearData",
  Check: "Check",
  Auth: "Auth",
  Store: "Store",
  DefStore: "DefStore",

  SetProducts: "SET_POS_PRODUCTS",
  AddProduct: "ADD_POS_PRODUCT",
  UpdateProduct: "UPDATE_POS_PRODUCT",
  RmvProduct: "RmvProduct",

  SetInventories: "SET_POS_INVENTORIES",
  SetInventory: "SET_POS_INVENTORY",
  AddInventory: "ADD_POS_INVENTORY",
  UpdateInventory: "UPDATE_POS_INVENTORY",  
  RmvInventory: "RmvInventory",

  SetCategories: "SET_POS_CATEGORIES",
  SetSearchResults: "SET_POS_SEARCH_RESULTS",
  AddCategory: "ADD_CATEGORY",
  UpdateCategory: "UPDATE_CATEGORY",
  RmvCategory: "RmvCategory",

  SetExpenseCats: "SET_EXPENSE_CATS",
  AddExpenseCat: "ADD_EXPENSE_CAT",
  UpdateExpenseCat: "UPDATE_EXPENSE_CAT",
  DeleteExpenseCat: "DELETE_EXPENSE_CAT", 

  SetPosItems: "SET_POS_ITEMS",

  SetSuppliers: "SET_POS_SUPPLIERS",
  RmvSupplier: "RmvSupplier",

  SetCustomers: "SET_POS_CUSTOMERS",
  RmvCustomer: "REMOVE_POS_CUSTOMER",
  
};

// ✅ helper: normalize error

export const normalizeError = (err) => {
  const responseData = err?.response?.data;


// console.log(
//   "FULL BACKEND ERROR:",
//   JSON.stringify(responseData, null, 2)
// );

  const raw =
    responseData?.message ||
    responseData ||
    err?.message;

  let message = "Request failed.";

  if (typeof raw === "string") {
    const parts = raw.split(",");
    message = parts[parts.length - 1]?.trim();
  }
  else if (typeof raw === "object" && raw !== null) {
    message =
      raw.msg ||
      raw.message ||
      raw.title ||
      "Request failed.";
  }

  return {
    status: err?.response?.status,
    message,
    result: responseData?.result || null,
  };
};

// ====================== GET ======================
export const get =
  (endpoint, type = ActionType.List, onComplete) =>
  (dispatch) => {
    api(endpoint)
      .get()
      .then((res) => {
        dispatch({
          type,
          payload: res.data,
        });
        onComplete?.(res.data, null);
      })
      .catch((err) => {
        const normalized = normalizeError(err);
        console.error("actions > pos GET:", normalized);
        onComplete?.(null, normalized);
      });
  };

// ====================== CLEAR ======================
export const clear =
  (dataType = [], type = ActionType.ClearLi) =>
  (dispatch) => {
    dispatch({
      type,
      payload: dataType,
    });
  };

  export const setVal = (payload, type) => (dispatch) => {
    dispatch({
      type,
      payload,
    });
  };

// ====================== GET BY ID ======================
export const getById =
  (endpoint, id, type = null, onComplete) =>
  (dispatch) => {
    api(endpoint)
      .getById(id)
      .then((res) => {
        if (type) {
          dispatch({
            type,
            payload: res.data,
          });
        }
        onComplete?.(res.data, null);
      })
      .catch((err) => {
        const normalized = normalizeError(err);
        console.error("actions > pos GET BY ID:", normalized);
        onComplete?.(null, normalized);
      });
  };

// ====================== GET BY OBJ ======================
export const getByObj =
  (endpoint, obj, type = ActionType.Data, onComplete) =>
  (dispatch) => {
    api(endpoint)
      .getByObj(obj)
      .then((res) => {
        dispatch({
          type,
          payload: res.data,
        });
        onComplete?.(res.data, null);
      })
      .catch((err) => {
        const normalized = normalizeError(err);
        console.error("actions > pos GET BY OBJ:", normalized);
        onComplete?.(null, normalized);
      });
  };

// ====================== POST ======================
export const post =
  (endpoint, data, type = ActionType.Data, onComplete) =>
  (dispatch) => {
    api(endpoint)
      .post(data)
      .then((res) => {
        dispatch({
          type,
          payload: res.data,
        });

        onComplete?.(res.data, null);
      })
      .catch((err) => {
        const normalized = normalizeError(err);

        console.error("actions > pos POST:", normalized);

        onComplete?.(null, normalized);
      });
  };

// ====================== PUT ======================
export const put =
  (endpoint, data, type = ActionType.Data, onComplete) =>
  (dispatch) => {
    api(endpoint)
      .put(data)
      .then((res) => {
        dispatch({
          type,
          payload: res.data,
        });
        onComplete?.(res.data, null);
      })
      .catch((err) => {
        const normalized = normalizeError(err);
        console.error("actions > pos PUT:", normalized);
        onComplete?.(null, normalized);
      });
  };

// ====================== DELETE ======================
export const Delete =
  (endpoint, id, type = ActionType.Delete, onComplete) =>
  (dispatch) => {
    api(endpoint)
      .delete(id)
      .then((res) => {

 console.log("DELETE RESPONSE:", res.data);

        dispatch({
          type,
          payload: res.data,
          id: id,
        });
        onComplete?.(res.data, null);
      })
      .catch((err) => {
        const normalized = normalizeError(err);
        console.error("actions > pos DELETE:", normalized);
        onComplete?.(null, normalized);
      });
  };

// ====================== GET SUPPLIERS BY STORE ======================
  export const getSuppliersByStore =
  (endpoint, storeId, type = null, onComplete) =>
  (dispatch) => {
    api(endpoint)
      .getById(storeId)
      .then((res) => {
        if (type) {
          dispatch({
            type,
            payload: res.data,
          });
        }

        onComplete?.(res.data, null);
      })
      .catch((err) => {
        const normalized = normalizeError(err);
        console.error(
          "actions > pos GET SUPPLIERS BY STORE:",
          normalized
        );

        onComplete?.(null, normalized);
      });
  };